import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { getPatientsAutocompleteApi } from "../apis/patientsApi";

export const usePreloadPatientsAutocomplete = (enabled = true) => {
  const qc = useQueryClient();

  useEffect(() => {
    if (!enabled) return;
    // Prefetch patients autocomplete so autocomplete is responsive
    qc.prefetchQuery({
      queryKey: ["patients", "autocomplete"],
      queryFn: () => getPatientsAutocompleteApi(),
      staleTime: 1000 * 60 * 5,
    }).catch(() => {});
  }, [qc, enabled]);
};


